import React from 'react';
import ReactDOM from 'react-dom';
import App from './Pages/App.js';

ReactDOM.render(
  <App />,
  document.getElementById("root")
)